function traceback(...arg): typeof console.trace {
  const { trace } = console;

  return function traceback(exception) {
    if (typeof exception.stack !== 'undefined') {
      trace.call(console, exception.stack);
    } else {
      trace.apply(console, ...arg);
    }
  };
}

export default traceback;
